export default "__VITE_ASSET__f936a904__"